import AvailabilityStatusCIrcule from "../../../../../utilities/AvailabilityStatusCIrcule";

export const PF_CONTROL_TABLE_COLUMNS = Object.freeze([
  {
    header: "№ nn",
    accessorKey: "number",
    size: 40,
    minSize: 40,
    maxSize: 70,
  },
  {
    header: "Status",
    accessorKey: "status",
    size: 50,
    minSize: 40,
    maxSize: 70,
    cell: circleColor => (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
        <AvailabilityStatusCIrcule color={circleColor.getValue()} />
      </div>
    ),
  },
  {
    header: "Pf №",
    accessorKey: "pfNumber",
    size: 130,
    minSize: 100,
    maxSize: 160,
  },
  {
    header: "Co №",
    accessorKey: "coNumber",
    size: 120,
    minSize: 100,
    maxSize: 150,
  },
  {
    header: "Request №",
    accessorKey: "requestNumber",
    size: 150,
    minSize: 130,
    maxSize: 180,
  },
  {
    header: "Note FEA",
    accessorKey: "noteFEA",
    size: 150,
    minSize: 120,
    maxSize: 350,
    enableColumnFilter: true,
    filterFn: "includesString",
  },
  {
    header: "CO Manager Comment",
    accessorKey: "noteCO",
    size: 150,
    minSize: 120,
    maxSize: 350,
    enableColumnFilter: true,
    filterFn: "includesString",
  },
  {
    header: "Manager FEA",
    accessorKey: "managerFEA",
    size: 150,
    minSize: 120,
    maxSize: 190,
  },
]);

export const DISAPPROVE_DETAILS_TABLE_COLUMNS = Object.freeze([
  {
    header: "№ nn",
    accessorKey: "number",
    size: 5,
  },
  {
    header: "SKU №",
    accessorKey: "skuNumber",
    size: 90,
  },
  {
    header: "Reason",
    accessorKey: "reason",
    alignStart: true,
    size: 140,
  },
  {
    header: "Description",
    accessorKey: "note",
    alignStart: true,
    size: 220,
  },
]);
